import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col } from "reactstrap";

// style
import "assets/css/loading.css";

// helpers
import { showMessage } from "../../helpers/message.js";
import { formateDateApi, dateAfterToDay } from '../../helpers/formats.js';
import { InputCEP } from "../../helpers/mask.js";

// api
import entradaindividual_api from "../../api/entradaindividual_api.js";
import cep_api from "../../api/cep_api.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function EntradaIndividualForm({ item, handleReturn }) {
  const { session, setLoading } = useAuth();

  const { register, errors, handleSubmit, setValue } = useForm({ mode: "onBlur" });

  const [form_disabled, set_form_disabled] = React.useState(false);

  const [list_table, set_list_table] = React.useState([])

  const Voltar = () => {
    handleReturn();
  }

  useEffect(() => {
    loadForm();
  }, []);

  const loadForm = () => {
      setLoading(true);
      entradaindividual_api.getItemFromFicha(session.localId, item == null ? 0 : item.entradaIndividualId).then(result => {
        setLoading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else {
          setValue("identificacao", result.data.identificacao);
          setValue("cep", result.data.cep);
          set_cep(result.data.cep);
          setValue("logradouro", result.data.logradouro);
          setValue("numero", result.data.numero);
          setValue("complemento", result.data.complemento);
          setValue("bairro", result.data.bairro);
          setValue("cidade", result.data.cidade);
          setValue("uf", result.data.uf);
          setValue("email", result.data.email);
          set_list_table(result.data.entradaIndividualTipoResiduo);

          set_form_disabled(!dateAfterToDay(result.data.dataHora));
        }
      });
  }

  const [cep, set_cep] = useState("");
  const handleCEPChange = (event) => {
    set_cep(event.target.value);
  }
  const handleCEPBlur = (event) => {
    if (event.target.value.length != 9)
      return;

    setLoading(true);
    cep_api.getEnderecoByCep(event.target.value).then(result => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", "Cep não localizado", 'error', null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
      }
      else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);
      }
    });
  }

  const handleQuantidadeChange = (tipoResiduoId, event) => {
    let _newlist = [];
    list_table.map(m => {
      if (m.tipoResiduoId == tipoResiduoId)
        m.quantidade = event.target.value;

      _newlist.push(m);
    })
    set_list_table(_newlist);
  }

  const onSubmit = (data) => {
    if (list_table.filter(f => f.quantidade != null && f.quantidade != "").length == 0) {
      showMessage("Aviso", "Informe as quantidades da entrada", 'error', null);
      return;
    }

    let json_submit = {
      entradaIndividualId: item == null ? 0 : item.entradaIndividualId,
      localId: session.localId,
      identificacao: data.identificacao,
      cep: data.cep.replace("-", ""),
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      email: data.email,
      dataHora: formateDateApi(new Date()),
      entradaIndividualTipoResiduo: list_table.filter(f => f.quantidade != null && f.quantidade != "")
    }

    setLoading(true);
    if (json_submit.entradaIndividualId == 0)
      entradaindividual_api.post(json_submit).then(result => handleReturnSubmit(result));
    else
      entradaindividual_api.put(json_submit).then(result => handleReturnSubmit(result));
  }

  const handleReturnSubmit = (result) => {
    setLoading(false);
    if (result.status !== 200) {
      showMessage("Aviso", result.message, 'error', null);
    }
    else {
      showMessage("Aviso", "Operação executada com sucesso", "success", function () { handleReturn() });
    }
  }

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Button color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Ficha de Entrada Individual</h4>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md="12"><h6 className="subtitleCard">Identificação</h6></Col>
                    <Col lg="6" md="12" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Nome/Razão Social:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="identificacao"
                          maxLength="14"
                          innerRef={register({ required: false })}
                          disabled={form_disabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="12" sm="12">
                      <FormGroup>
                        <label className="form-control-label">E-mail</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="email"
                          maxLength="60"
                          innerRef={register({ required: false })}
                          disabled={form_disabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12"><h6 className="subtitleCard">Endereço</h6></Col>
                    <Col lg="2" md="3" sm="12">
                      <FormGroup>
                        <label className="form-control-label">CEP</label>
                        <InputCEP
                          type="text"
                          name="cep"
                          onChange={handleCEPChange}
                          onBlur={handleCEPBlur}
                          value={cep}
                          autocomplete="off"
                          inputRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Logradouro</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="text"
                          name="logradouro"
                          maxLength="150"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="2" md="2" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Número</label>
                        <Input className="form-control"
                          maxLength="10"
                          autocomplete="off"
                          type="text"
                          name="numero"
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.numero && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="2" md="2" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Complemento</label>
                        <Input className="form-control"
                          maxLength="50"
                          autocomplete="off"
                          type="text"
                          name="complemento"
                          innerRef={register({ required: false })}
                          disabled={form_disabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="5" md="5" sm="12">
                      <FormGroup>
                        <label className="form-control-label">Bairro</label>
                        <Input className="form-control"
                          maxLength="150"
                          autocomplete="off"
                          type="text"
                          name="bairro"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="5" md="5" sm="10">
                      <FormGroup>
                        <label className="form-control-label">Cidade</label>
                        <Input className="form-control"
                          maxLength="150"
                          autocomplete="off"
                          type="text"
                          name="cidade"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="2" md="2" sm="2">
                      <FormGroup>
                        <label className="form-control-label">UF</label>
                        <Input className="form-control"
                          maxLength="2"
                          autocomplete="off"
                          type="text"
                          name="uf"
                          readOnly={true}
                          innerRef={register({ required: true })}
                          disabled={form_disabled}
                        />
                        {errors.uf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12"><h6 className="subtitleCard">Lista de Resíduos</h6></Col>
                    <Col lg="8" md="8" sm="8">
                      <label className="form-control-label">Resíduo</label>
                    </Col>
                    <Col lg="2" md="2" sm="2">
                      <label className="form-control-label">Quantidade</label>
                    </Col>
                    <Col lg="2" md="2" sm="2">
                      <label className="form-control-label">Unidade Medida</label>
                    </Col>
                  </Row>
                  {list_table.map((m, key) => (
                    <Row key={key}>
                      <Col lg="8" md="8" sm="8">
                        <FormGroup>
                          <Input type="text" readOnly="true" value={m.tipoResiduoDescricao}></Input>
                        </FormGroup>
                      </Col>
                      <Col lg="2" md="2" sm="2">
                        <FormGroup>
                          <Input type="number" disabled={form_disabled} onChange={(e) => handleQuantidadeChange(m.tipoResiduoId, e)} value={m.quantidade}></Input>
                        </FormGroup>
                      </Col>
                      <Col lg="2" md="2" sm="2">
                        <FormGroup>
                          <Input type="text" readOnly="true" value={m.tipoResiduoUnidade}></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  ))}
                  {!form_disabled &&
                    <Row>
                      <Col lg="12" md="12" sm="12" className="text-center">
                        <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                      </Col>
                    </Row>
                  }
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>

    </>
  );
}

